import { render, staticRenderFns } from "./reminders-popover.vue?vue&type=template&id=ecbc5330"
import script from "./reminders-popover.vue?vue&type=script&lang=js"
export * from "./reminders-popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports